

import { typeFailureService } from "@/services/type-failure.service";
import TypeFailureModel from "../models/type-failure";
import {Component, Vue, Watch} from "vue-property-decorator";
import { VForm } from '@/types';
import { authService } from "@/services/authentification.service";
import ConfirmComponent from "@/components/ConfirmComponent.vue";
import {Filter, Sort} from "@/models/common";

@Component({
  components: { ConfirmComponent }
})
export default class TypeFailure extends Vue {
  private typeFailures: Array<TypeFailureModel> = new Array<TypeFailureModel>();
  private editedItem = new TypeFailureModel();
  private defaultItem = new TypeFailureModel();

  private displayEditDialog = false;
  private displayConfirmDialog = false;
  private editedIndex = -1;
  private totalTypeFailures = 0;
  private loading = true;

  private saveLoading = false;
  private deleteLoading = false;

  private pagination = {
    page: 1,
    itemsPerPage: 50,
    pageStart: 0,
    pageStop: 50,
    pageCount: 0,
    itemsLength: 0,
  };

  private options = {
    itemsPerPage: 50,
    page: 1
  };

  private headers = [
    { text: "Категория", value: "category", sortable: false },
    { text: "Описание", value: "specification", sortable: false },
    { text: "Действия", value: "actions", sortable: false },
  ];

  private valid = true;

  async mounted() {
    const employee = await authService.getCurrentUser();
    if (employee?.role?.name === "Root") {
      this.headers.unshift({text: "Ид", sortable: false, value: "id"});
    }
  }

  @Watch("options", {deep: true})
  async loadTypeFailures() {
    try {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const offset = (page - 1) * itemsPerPage;
      const count = itemsPerPage == -1 ? this.totalTypeFailures : itemsPerPage;
      const sorts = new Array<Sort>();
      const filters = new Array<Filter>();

      this.pagination.pageStart = offset;
      this.pagination.pageStop = offset + itemsPerPage;

      const res = await typeFailureService.getPageData(offset, count, sorts, filters);
      this.typeFailures = res.data.collection;
      this.totalTypeFailures = res.data.count;
      this.pagination.itemsLength = res.data.count;
      this.pagination.pageCount = Math.ceil(res.data.count / 50);
    }
    catch (ex) {
      this.$toast.error("Ошибка при загрузке данных");
    }
    this.loading = false;
  }

  showEditDialog(item: TypeFailureModel) {
    this.editedIndex = this.typeFailures.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayEditDialog = true;
  }

  showDeleteDialog(item: TypeFailureModel) {
    this.editedIndex = this.typeFailures.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayConfirmDialog = true;
  }

  async deleteTypeFailure() {
    try {
      this.deleteLoading = true;
      const item = this.editedItem;
      await typeFailureService.delete(item.id);
      await this.loadTypeFailures();
    }
    catch (ex) {
      this.$toast.error("Ошибка при удалении");
    }
    this.deleteLoading = false;
    this.close();
  }

  close() {
    this.displayConfirmDialog = false;
    this.displayEditDialog = false;
    this.form?.resetValidation();
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  get form(): VForm {
    return this.$refs.form as VForm;
  }

  async save() {
    this.form?.validate();
    if (this.valid) {
      const index = this.editedIndex;
      this.saveLoading = true;
      try {
        if (index > -1) {
          await typeFailureService.update(this.editedItem);
        } else {
          await typeFailureService.create(this.editedItem);
        }
        await this.loadTypeFailures();
      }
      catch (ex) {
        this.$toast.error("Ошибка при сохранении");
      }
      this.saveLoading = false;
      this.close();
    }
  }
}
